import React, { Fragment, useEffect, useContext } from "react";
import { Box, List, ListItem, ListItemText, Link, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import ProjectContext from "../../context/project/ProjectContext";

const QuickLinks = () => {
  const projectContext = useContext(ProjectContext);
  const { selectedProject } = projectContext;
  const projectId =
    selectedProject && selectedProject.ID ? selectedProject.ID : "-1";
  return (
    <Fragment>
      <Box className='container contA'>
        <Grid
          container
          spacing={2}
          xs={12}
          sx={{
            margin: 2,
            px: 2,
            // width: "50vh",
            // minHeight: "450px",
            justifyContent: "flex-start",
            justifyItems: "flex-start",
            fontWeight: "bold",
            fontSize: "30px",
            flexDirection: "row",
            display: "flex",
            border: 2,
            borderColor: "text.primary",
            borderRadius: 1,
          }}
        >
          <List sx={{ margin: "50px", marginLeft: "100px" }}>
            <ListItem disableGutters>
              <Typography
                variant='body2'
                noWrap
                sx={{
                  fontWeight: 600,
                  fontSize: "1.15rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                QUICK LINKS TO MAPS
              </Typography>
            </ListItem>
            <ListItem
              disableGutters
              //   sx={{
              //     borderBottom: "1px solid grey",
              //     py: 2,
              //   }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_DESIGN}&projectId=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Detailed Design Map' />
              </Link>
            </ListItem>
            <ListItem
              disableGutters
              //   sx={{
              //     borderBottom: "1px solid grey",
              //     py: 2,
              //   }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_CONSTRUCTION_MAP}&projectId=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Construction & Inspection Map' />
              </Link>
            </ListItem>
            <ListItem disableGutters>
              <Typography
                variant='body2'
                noWrap
                sx={{
                  fontWeight: 600,
                  fontSize: "1.15rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                QUICK LINKS TO REPORTS
              </Typography>
            </ListItem>
            <ListItem
              disableGutters
              //   sx={{
              //     borderBottom: "1px solid grey",
              //     py: 2,
              //   }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_INSPECTION_REPORT}&ProjectID=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Inspection Report' />
              </Link>
            </ListItem>
            <ListItem
              disableGutters
              //   sx={{
              //     borderBottom: "1px solid grey",
              //     py: 2,
              //   }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_INCIDENT_REPORT}&projectId=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Incident Report' />
              </Link>
            </ListItem>
            <ListItem
              disableGutters
              // sx={{ py: 2 }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_TABULATION_REPORT}&ProjectID=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Tabulation Report' />
              </Link>
            </ListItem>
            <ListItem
              disableGutters
              //   sx={{
              //     borderBottom: "1px solid grey",
              //     py: 2,
              //   }}
            >
              <Link
                href={`${process.env.REACT_APP_EXP_CUP_REPORT}&projectId=${projectId}`}
                target='_blank'
                underline='hover'
                sx={{ width: "100%" }}
              >
                <ListItemText primary='Construction Tabulation Report' />
              </Link>
            </ListItem>
          </List>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default QuickLinks;
